import * as types from "./user.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { User, UserUpdate } from "../../interfaces/User";
import { UserCreateResponse, UserDetailResponse, UserListResponse, UserUpdateResponse } from "./types";
import { Employee } from "../../interfaces/Employee";
import { UserRole } from "../../interfaces/UserRole";

export const selectUser = (user: User | null) => action(types.SELECT_USER, { user });

export const updateEmployee = (newId: string, newDetail: Employee) => action(types.UPDATE_EMPLOYEE, { newId, newDetail });

export const updateRole = (newId: number, newDetail: UserRole) => action(types.UPDATE_ROLE, { newId, newDetail });

export const updateStatus = (value: number) => action(types.UPDATE_STATUS, { value });

export const initializeCreateUser = () => {
  const user: UserUpdate | null = {
    NIK: '',
    ROLE_ID: 0,
    STATUS: 0
  }

  return action(types.INITIALIZE_CREATE_USER, { user })
}

export const getUserAsync = createAsyncAction(
  types.GET_USER_REQUEST,
  types.GET_USER_SUCCESS,
  types.GET_USER_FAILURE
)<undefined, UserListResponse, ErrorResponse>();

export const getDetailUserAsync = createAsyncAction(
  types.GET_DETAIL_USER_REQUEST,
  types.GET_DETAIL_USER_SUCCESS,
  types.GET_DETAIL_USER_FAILURE
)<{ id: number }, UserDetailResponse, ErrorResponse>();

export const updateUserAsync = createAsyncAction(
  types.UPDATE_USER_REQUEST,
  types.UPDATE_USER_SUCCESS,
  types.UPDATE_USER_FAILURE
)<User, UserUpdateResponse, ErrorResponse>();

export const createUserAsync = createAsyncAction(
  types.CREATE_USER_REQUEST,
  types.CREATE_USER_SUCCESS,
  types.CREATE_USER_FAILURE
)<User, UserCreateResponse, ErrorResponse>();
